import React from "react";
import { connect } from "react-redux";
import { useMutation } from "@apollo/react-hooks";
import uniqid from "uniqid";
import logo from "../../assets/white-logo.svg";
import { setUser, setUserInfo } from "../../lib/session";
import { USER_LOGIN } from "../../lib/graphql/mutations";
import LoginForm from "../../components/Forms/LoginForm/index";
import { setPlayingAction } from "../../lib/store/actions/pageActions";

const Login = ({ pageForm, history, track, dispatch }) => {
  const [userLogin, { data, error }] = useMutation(USER_LOGIN);

  const mutationId = uniqid();
  const { user: { values: { password, email } = {} } = {} } = pageForm;

  if (!error) {
    let account = "";
    const { userLogin: { authToken } = {} } = data || {};

    if (authToken && email) {
      account = {
        username: email,
        type: "parent",
        token: authToken,
        home: "/children_teens"
      };
      if (account) {
        setUser(account);
        track("login", "user", ({ data }) => {
          const { trackActivity: { user: userData } = {} } = data || {};
          setUserInfo("data", userData);
          history.push(account.home);
          window.location.reload();
        });
      }
    }
  }

  return (
    <div className="login">
      <div className="imageContainer hero-container secondary">
        <div className="logoContainer">
          <img src={logo} alt="logo" className="logo" />
        </div>
        <div className="gradient" />
      </div>
      <div className="login-container">
        {error && (
          <div className="login-error">
            You cannot login with the credentials you provided.
          </div>
        )}
        <LoginForm
          callbackFunc={() =>
            userLogin({
              variables: { username: email, password, mutationId },
              errorPolicy: "all"
            })
          }
          buttons={{
            next: "Sign in"
          }}
        />
        <div style={{ paddingTop: ".5em", textAlign: "center" }}>
          For help, please contact: Support@InnerPeaceTime.com
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  pageForm: state.form
});

export default connect(mapStateToProps)(Login);
